import {LocalStorageObject} from '../Utilities';

export class RegistrationCodesDTO implements LocalStorageObject {
  registrationCodes: Array<string> = [];

  fromStorage(data: any) {
    const registrationCodesDTO = new RegistrationCodesDTO();
    registrationCodesDTO.registrationCodes = data.registrationCodes;
    return registrationCodesDTO;
  }
}
